export enum EGalleryCommand {
	takePicture,
	pickFile,
	saveFiles,
	pickImage
}